export default __webpack_public_path__ + "static/media/interior@2x.8f3a7a5e.png";